<template>
  <div class="page-content bg-img directions">
    <img src="@/assets/images/second-bg.png" class="intro-bg" alt="image description"/>
    <div class="text-container">
      <div class="text-content text-content-direction">
        <div class="text-col">
          <h2 class="text-center">Don’t Sweat It!</h2>
          <p>It’s time to show what you know about not sweating it! Here’s how it works:</p>
          <ol class="numbered-list">
            <li v-for="item in items" :key="item" v-html="item"></li>
          </ol>
        </div>
      </div>
      <div class="btn-holder">
        <a href="#" class="btn-next" @click.prevent="goToNextStep">
          <span>Start the game</span>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters, mapMutations } from "vuex";

  export default {
    name: 'Directions',
    computed: {
      ...mapGetters({
        items: 'getDirectionsItems'
      })
    },
    methods: {
      ...mapMutations({
        next: 'nextStep',
        stop: 'stop'
      }),
      goToNextStep() {
        this.next();
        this.stop('theme_music');
      }
    },
    mounted() {
      window.dispatchEvent(new Event('resize'));
    }
  }
</script>
